<template>
	<div class=" flex-center">
		<div :class="{ loginBox:true, compact:props.compact }">
			<div class="top">
				<div class="parallelogram"></div>
				<div class="left">
					<div class="logo flex-center">
						<img :src="`/assets/images/mainbody/logo.png?WebVersion=${$WebVersion}`">
						<span class="text" v-if="mainbodyConfig.header_show_site_name">{{mainbodyConfig.site_name}}</span>
					</div>
					<div class="title">{{title}}</div>
				</div>
				
				<div class="close" @click="close" v-if="regStep != 4"></div>
			</div>
			<div class="main">
				<div class="switchLogoMode" v-if="!isReg && regStep != 4">
					<div :class="{item:true,'flex-center':true,active:loginMode==2}" @click="loginModeChange(2)">{{ $t('components.login.passwordLogin', '密码登录') }}</div>
					<div :class="{item:true,'flex-center':true,active:loginMode==1}" @click="loginModeChange(1)">{{ $t('components.login.codeLogin', '验证登录') }}</div>
					<div :class="{item:true,'flex-center':true,active:loginMode==3}" @click="loginModeChange(3)" >{{ $t('components.login.qrLogin', '扫码登录') }}</div>
					<div class="line">
						<div :class="{act:true,toCenter:loginMode==1,toRight:loginMode==3}"></div>
					</div>
				</div>
				<div class="formBox" :style="`${isReg?'margin-top:70px;':''}`">
					<el-form :model="form" v-if="loginMode==2&&regStep==1" ref="formRef" :rules="rules">
						<el-form-item label="" prop="account">
							<el-select v-model="form.p" placeholder="" style="width: 113px" class="mobileAreaCode" @change="areaCodeChange">
								<template #header>
									<div>
										<el-input v-model="tel_Keyword" clearable :placeholder="$t('components.login.inputKeyword', '请输入关键字')" />
									</div>
								</template>
								<template #label="{ value }">
									<span>+</span>
									<span>{{ value }}</span>
								</template>
								<el-option :label="item.name" :value="item.tel" v-for="(item,i) in mobileAreaCodeView" :key="i">
									<div class="customLabel">
										<div class="label flex-align">
											<div class="flag">
												<img v-if="item.short" :src="findNationalFlag(item.short)" >
											</div>
											{{item.name}}
										</div>
										<div class="tel">+{{item.tel}}</div>
									</div>
								</el-option>
							</el-select>
							<el-input v-model="form.account" @keyup.enter="doLogin" @paste="handlePaste" style="width: 247px;" :placeholder="$t('components.login.inputPhone', '请输入手机号')" @input="cacheAccountFn" />
						</el-form-item>
						<el-form-item label="" prop="password">
							<el-input :type="showPassword?'text':'password'" v-model="form.password" @keyup.enter="doLogin" :placeholder="$t('components.login.inputPassword', '请输入密码')">
								<template #append>
									<div class="showPassword" @click="showPasswordFn">
										<img src="@/assets/images/showPassword-open.png" v-if="showPassword">
										<img src="@/assets/images/showPassword-close.png" v-else>
									</div>
								</template>
							</el-input>
						</el-form-item>
					</el-form>
					<el-form :model="form" v-else-if="loginMode==1&&regStep==1" ref="formRef" :rules="rules">
						<el-form-item label="" prop="account">
							<el-select v-model="form.p" placeholder="" style="width: 113px" class="mobileAreaCode" @change="areaCodeChange">
								<template #header>
									<div>
										<el-input v-model="tel_Keyword" clearable :placeholder="$t('components.login.inputKeyword', '请输入关键字')" />
									</div>
								</template>
								<template #label="{ value }">
									<span>+</span>
									<span>{{ value }}</span>
								</template>
								<el-option :label="item.name" :value="item.tel" v-for="(item,i) in mobileAreaCodeView" :key="i">
									<div class="customLabel">
										<div class="label flex-align">
											<div class="flag">
												<img v-if="item.short" :src="findNationalFlag(item.short)" >
											</div>
											{{item.name}}
										</div>
										<div class="tel">+{{item.tel}}</div>
									</div>
								</el-option>
							</el-select>
							<el-input v-model="form.account" @paste="handlePaste" style="width: 247px;" :placeholder="$t('components.login.inputPhone', '请输入手机号')" @input="cacheAccountFn" />
						</el-form-item>
						<el-form-item label="" prop="password">
							<el-input v-model="form.password" style="width: 247px;" :placeholder="$t('components.login.inputCode', '请输入验证码')" />
							<el-button class="obtainVerificationCode flex-center" :loading="getCodeloading" @click="getCode">{{obtainVerificationCode}}</el-button>
						</el-form-item>
					</el-form>
					<el-form :model="form" v-else-if="regStep==2" ref="formRef" :rules="rules">
						<el-form-item label="" prop="password1">
							<div class="password1 flex-align" @click="clickPassword">
								<el-input ref="showPassword1Ref" :type="showPassword1?'text':'password'" :class="{disabled:!!randomPassword}"  v-model="form.password1" :placeholder="$t('components.login.passwordRule', '6~15位密码，必须包含字母和数字')">
									<template #append>
										<div class="showPassword" @click.stop="showPasswordFn(1)">
											<img src="@/assets/images/showPassword-open.png" v-if="showPassword1">
											<img src="@/assets/images/showPassword-close.png" v-else>
										</div>
									</template>
								</el-input>
								<el-tooltip
									effect="dark"
									:content="$t('components.login.randomPassword', '随机密码')"
									placement="bottom"
								  >
									<img class="iconDice" src="@/assets/images/icon-dice.png" @click.stop="randomPasswordFn">
								</el-tooltip>
							</div>
						</el-form-item>
						<el-form-item label="" prop="password2" v-if="!randomPassword">
							<el-input :type="showPassword2?'text':'password'" v-model="form.password2" :placeholder="$t('components.login.inputPasswordAgain', '请再次输入密码')">
								<template #append>
									<div class="showPassword" @click="showPasswordFn(2)">
										<img src="@/assets/images/showPassword-open.png" v-if="showPassword2">
										<img src="@/assets/images/showPassword-close.png" v-else>
									</div>
								</template>
							</el-input>
						</el-form-item>
					</el-form>
					<el-form :model="userInfoOpt.editModel" v-else-if="regStep==4" ref="userInfoFormRef" v-loading="userInfoOpt.loading" >
						<el-form-item >
							<el-row class="flex-center">
								<el-upload
									class="avatar-wrapper"
									:before-upload="userInfoOpt.beforePhotoUpload"
									:http-request="userInfoOpt.handleUpload"
									:on-progress="userInfoOpt.handleProgress"
									:on-success="userInfoOpt.handlePhotoUploadSuccess"
									:on-error="userInfoOpt.handleUploadError"
									:show-file-list="false"
									:limit="1"
									:on-exceed="userInfoOpt.handleExceed"
									accept=".jpg,.jpeg,.png,.pdf"
									:disabled="false"
									ref="avatarUploadRef"
								>
									<div class="avatarBox" v-loading="userInfoOpt.uploading">
										<img :src="ImageParameterSplicing(userInfoOpt.editModel?.avatar || '',500)" :alt="$t('components.login.userAvatar', '用户头像')" class="avatar" @error="avatarError" />
										<!-- <img class="icon-camera" src="@/assets/images/nember-camera.png" > -->
										<div class="iconBox flex-center">
											<el-icon size="12"><Edit /></el-icon>
										</div>
									</div>
								</el-upload>
							</el-row>
						</el-form-item>
						<el-form-item >
							<el-row class="flex-center">
								<el-input class="nickName" v-autofocus v-model="userInfoOpt.editModel.nickName" :placeholder="$t('components.login.nickNamePlaceholder', '起一个酷酷的名字让主播记住你')" />
							</el-row>
						</el-form-item>
					</el-form>
					<div class="scanToLogin flex-column flex-center" v-else-if="loginMode == 3">
						<div class="qrcodeBox" v-loading="qrcodeOpt.loading">
							<div class="status flex-center" v-if="qrcodeOpt.status == 1" >{{ $t('components.login.confirmOnPhone', '请在手机端确认') }}</div>
							<div class="status flex-center" v-if="qrcodeOpt.status == 2" >{{ $t('components.login.confirmed', '已确认') }}</div>
							<div class="status flex-center" v-if="qrcodeOpt.status == 3" @click.stop="qrLoginCreate">{{ $t('components.login.rejectedRetry', '已拒绝，重新获取') }}</div>
							<div class="status flex-center" v-if="qrcodeOpt.status == 4" @click.stop="qrLoginCreate">{{ $t('components.login.expiredRetry', '已过期，重新获取') }}</div>
							<vue-qr style="vertical-align: middle;"
								:text="qrcodeOpt.text"
								:size="218"
								level="H"
							></vue-qr>
						</div>
						<div class="tips">
							<span class="text">{{ $t('components.login.use', '使用') }}</span>
							<el-popover placement="bottom" :width="302" :popper-class="`header popoverContent `">
								<template #reference>
									<span class="text appText">&nbsp;&nbsp;{{ $t('components.login.appMyPage', '{siteName}手机APP-我的', { siteName: mainbodyConfig.site_name }) }}&nbsp;&nbsp;</span>
								</template>
								<div class="downloadPopupContent flex-column style3">
									<div class="top flex-column flex-align">
										<div class="title">{{ $t('components.login.appTitle', '{siteName}APP', { siteName: mainbodyConfig.site_name }) }}</div>
										<div class="subTitle">{{ $t('components.login.scanToDownload', '扫码下载{siteName}APP', { siteName: mainbodyConfig.site_name }) }}</div>
										<div class="qrCodeBox flex-center">
											<vue-qr style="vertical-align: middle;" v-if="installGuideUrl"
												:text="installGuideUrl"
												:size="182"
												:logoMargin="2"
												level="H"
											></vue-qr>
										</div>
									</div>
									<div class="bottom flex-center flex-column">
										<div>{{ $t('components.login.scanWithBrowser', '用手机浏览器扫一扫') }}</div>
										<div>{{ $t('components.login.wonderfulShown', '精彩马上呈现') }}</div>
									</div>
								</div>
							</el-popover>
							<span class="text">{{ $t('components.login.scanToLogin', '扫一扫登录') }}</span>
							<img class="iconRefresh" src="@/assets/images/Refresh.png" alt="" @click.stop="qrLoginCreate">
						</div>
					</div>
				</div>
				<div v-show="loginMode==2 && regStep!=4" class="other" :abc="regStep">
					<el-button link class="forgotPassword" style="color:#9E9E9F;font-size: 13px;" @click="forgotPasswordFn">{{loginMode==2?$t('components.login.forgotPassword', '忘记密码'):''}}</el-button>
				</div>

				<div class="btnBox" v-if="loginMode != 3">
					<el-button :class="{item:true,login:true,}" @click="doLogin()" :loading="loading" v-if="!isReg && regStep != 4">
						{{ $t('components.login.login', '登录') }}
					</el-button>
					<el-button :class="{item:true,login:true,grey:!form.password}" @click="doreg(2)" :disabled="!form.password" :loading="loading" v-if="isReg&&regStep==1">
						{{ $t('components.login.register', '注册') }}
					</el-button>
					<el-button :class="{item:true,reg:true}" @click="reg" v-if="regStep==1">
						{{isReg?$t('components.login.goLogin', '去登录'):$t('components.login.register', '注册')}}
					</el-button>
					<el-button :class="{item:true,login:true,grey:!allowReg}" @click="doreg(3)" :disabled="!allowReg" :loading="loading" v-else-if="regStep==2">
						{{ $t('components.login.completeRegister', '完成注册') }}
					</el-button>
					<el-button :class="{item:true,login:true,disabled:userInfoOpt.editModel.nickName.trim() === ''}" @click="userInfoOpt.complete" :loading="userInfoOpt.loading" v-else-if="regStep==4" :disabled="userInfoOpt.editModel.nickName.trim() === ''">
						<span v-if="isReg">{{ $t('components.login.completeRegister', '完成注册') }}</span>
						<span v-else>{{ $t('components.login.completeProfile', '补全资料') }}</span>
					</el-button>
				</div>
				<div class="" v-if="isReg && regStep==1">
					<checkBox v-model="agree">
						{{ $t('components.login.agreePrefix', '我已阅读并同意') }}<el-link type="success" @click.stop="toAgreement">{{ $t('components.login.agreement', '《用户协议和隐私政策》') }}</el-link>
					</checkBox>
				</div>
			</div>
		</div>
		<MFA ref="MFARef" @success="MFASuccess"></MFA>
	</div>
</template>

<script setup>
	import vueQr from "vue-qr/src/packages/vue-qr.vue";
	import MFA from "./components/MFA";
	import {mobileAreaCode} from "./utils";
	import defaultAvatar from "@/assets/images/defaultAvatar.png";
	import {ref,reactive,getCurrentInstance,onMounted,computed,watch, onUnmounted} from "vue";
	let {proxy} = getCurrentInstance();
	import {useStore} from '@/store';
	let store = useStore();
	let userInfo = computed(() => store.state.user);
	let startUp = computed(()=>store.state.startUp);
	let props = defineProps({
		mode:{
			type:[Number,String],
			default:0
		},
		compact:{
			type:Boolean,
			default:false,
		}
	})
	let _form = {
		2:{
			p:'86',
			account:'',
			password:'',
		},
		1:{
			p:'86',
			account:'',
			password:'',
		}
	},
	_rules = {
		2:{
			account: [{
				required: true,
				message: "请输入账号"
			}],
			password: [{
				required: true,
				message: "请输入密码"
			}],
			password1: [{
				required: true,
				// message: "6~15位密码，必须包含字母和数字",
				trigger:'change',
				validator:(rule,value,callback)=>{
					// if(randomPassword.value){
					// 	callback();
					// }else{
						if(value==='' || !(/.{6,}/.test(value) && /\d/.test(value) && /[A-z]/.test(value)) || String(value).length>15){
							callback(new Error('6~15位密码，必须包含字母和数字'));
							allowReg.value = false;
						}else{
							allowReg.value = value == form.password2;
							callback();
						}
					// }
				}
			}],
			password2: [{
				required: true,
				// message: "请输入再次输入密码",
				trigger:'change',
				validator:(rule,value,callback)=>{
					// if(randomPassword.value){
					// 	callback();
					// }else{
						if(value===''){
							callback(new Error('请输入再次输入密码'));
							allowReg.value = false;
						}else{
							if(value != form.password1){
								callback(new Error('两次密码不一致'));
								allowReg.value = false;
							}else{
								allowReg.value = value == form.password1;
								callback();
							}
						}
					// }
				}
			}],
		},
		1:{
			account: [{
				required: true,
				message: "请输入手机号"
			}],
			password: [{
				required: true,
				message: "请输入验证码"
			}],
			
		}
		
	},
	title = ref('登录'),
	form = reactive({}),
	rules = reactive({}),
	formRef = ref(),
	loginMode = ref(2),
	loading = ref(false);
	
	Object.assign(form,_form[loginMode.value]);
	Object.assign(rules,_rules[loginMode.value]);
	let obtainVerificationCode = ref('获取验证码');
	let loginModeChange = (n)=>{
		loginMode.value = n;
		if(n != 3){
			proxy.clearObject(form);
			Object.assign(form,_form[n],{account:cacheAccount.value});
			proxy.clearObject(rules);
			Object.assign(rules,_rules[n]);

			// 重置二维码
			clearInterval(qrcodeOpt.countdownInterval);
			clearInterval(qrcodeOpt.qrLoginStatusInterval);
			Object.assign(qrcodeOpt,{
				loading:false,
				text:'',
				eventID:'',
				countdownInterval:null,
				expireTime:0,
				status:0,
			});
		}else{
			qrLoginCreate();
		}
	}
	let areaCodeChange = (e)=>{
		_form[1].p = _form[2].p = e;
	}
	let cacheAccount = ref('');
	let cacheAccountFn = (e)=>{
		cacheAccount.value = e;
	}
	let tel_Keyword = ref('');
	let national_flag = [];
	let mobileAreaCodeView = computed(()=>{
		let needSort = ['86','852','853','886'];
		let _map = new Map(needSort.map((e,i)=>[e,i]));
		let front = mobileAreaCode.filter(e=>needSort.find(n=>n == e.tel)).sort((a,b)=>_map.get(a.tel) - _map.get(b.tel));
		let data = front.concat(mobileAreaCode.filter(e=>!needSort.find(n=>n == e.tel)).sort((a,b)=>a.tel - b.tel));
		// console.log('mobileAreaCodeView',data);
		if(tel_Keyword.value){
			data = data.filter(e=>RegExp(`${tel_Keyword.value}`).test(e.name) || RegExp(`${tel_Keyword.value}`).test(e.tel));
		}
		return data;
	});
	mobileAreaCodeView.value.filter(e=>e.short).forEach(e=>{
		try{
			national_flag.push({
				short:e.short,
				url:require(`@/assets/images/national_flag_svg/${e.short.toLocaleLowerCase()}.svg`),
			})
		}catch(err){
			console.log('requireFlag-err',err);
		}
	})
	let findNationalFlag = (short)=>{
		let has = national_flag.find(e=>e.short.toLocaleLowerCase() == short.toLocaleLowerCase());
		return has?has.url:'';
	}
	let showPassword = ref(false),
		showPassword1 = ref(false),
		showPassword2 = ref(false);
	let showPasswordFn = (type)=>{
		if(type==1){
			showPassword1.value = !showPassword1.value;
		}else if(type==2){
			showPassword2.value = !showPassword2.value;
		}else{
			showPassword.value = !showPassword.value;
		}
	}
	let deviceid = null;
	onMounted(()=>{
		deviceid = proxy.localStorage.getItem('qx2DeviceID');
		getInstallGuideUrl();
	})

	let qrcodeOpt = reactive({
		loading:false,
		text:'',
		eventID:'',
		countdownInterval:null,
		expireTime:0,
		status:0,
		createCountdown:(expireSeconds)=>{
			qrcodeOpt.expireTime = Date.now() + expireSeconds * 1000;
			clearInterval(qrcodeOpt.countdownInterval);
			qrcodeOpt.countdownInterval = setInterval(()=>{
				if(Date.now() > qrcodeOpt.expireTime){//过期了
					clearInterval(qrcodeOpt.countdownInterval);//关掉定时器
					// qrLoginCreate();//重新获取二维码
					qrcodeOpt.status = 4;// 标记过期
					qrcodeOpt.text = '已过期，请重新获取';
				}
			},500)
		},
		qrLoginStatusInterval:null,
		qrLoginStatus:()=>{
			clearInterval(qrcodeOpt.qrLoginStatusInterval);
			qrcodeOpt.qrLoginStatusInterval = setInterval(()=>{// 轮询二维码状态
				proxy.request({
					url:"/QrLoginStatus",
					method:'post',
					data:{
						eventID:qrcodeOpt.eventID,
					},
					notps:true,
				}).then(({data})=>{
					if(data?.code == 200){
						console.log('二维码的状态',data.data);
						if([3,4].some(e=>e == data.data.status)){
							clearInterval(qrcodeOpt.qrLoginStatusInterval);
						}
						qrcodeOpt.status = data.data.status;
						if(qrcodeOpt.status == 2){//已确认
							// 处理确认操作后的用户信息
							if(deviceid == data.data.deviceID){
								proxy.localStorage.setItem("token", data.data.userToken);
								proxy.getUserInfo(store).then(()=>{
									// 处理完用户信息关闭窗口
									close();
								});
							}
						}
						if(qrcodeOpt.status == 3){//已拒绝
							//提示用户已拒绝并关闭窗口
							proxy.$message.error('App端取消了本次登录');
							close();
						}
					}else{
						if(data?.code == 200){//二维码过期会401
							clearInterval(qrcodeOpt.qrLoginStatusInterval);
							qrcodeOpt.status = 4;// 标记过期
							qrcodeOpt.text = '已过期，请重新获取';
						}
					}
				}).catch(err=>{
					clearInterval(qrcodeOpt.qrLoginStatusInterval);
					console.log(err);
				})
			},2000);
			
		}
	})
	
	let qrLoginCreate = ()=>{
		qrcodeOpt.loading = true;
		proxy.request({
			url:"QrLoginCreate",
			method:'post',
		}).then(({data})=>{
			if(data?.code == 200){
				qrcodeOpt.eventID = data.data.eventID;
				qrcodeOpt.text = data.data.qrCodeUrl;
				qrcodeOpt.status = 0;
				// 启动计时
				qrcodeOpt.createCountdown(data.data.expireSeconds);
				qrcodeOpt.qrLoginStatus();//查询二维码状态
			}
		}).catch(err=>{
			console.log(err);
		}).finally(()=>{
			qrcodeOpt.loading = false;
		})
	}
	onUnmounted(()=>{
		clearInterval(qrcodeOpt.countdownInterval);
		clearInterval(qrcodeOpt.qrLoginStatusInterval);
	})
	
	let installGuideUrl = ref('');
	watch(()=>startUp.value,()=>{
		getInstallGuideUrl();
	},{deep:true})
	// 当前协议://{H5域名}/openInstallGuide
	let getInstallGuideUrl = ()=>{
		if(!Object.keys(startUp.value).length)return;
		if(startUp.value.safeDomains?.length==0) {
			console.log('未配置服务地址，敬请期待！')
			return;
		}
		let protocol = window.location.protocol;
		let _safeDomains = startUp.value.safeDomains?.map(e=>e.replace(RegExp('https{0,1}://'), ''));
		let safeDomain = _safeDomains[0];
		installGuideUrl.value = `${protocol}//${safeDomain}/openInstallGuide`;
	}

	// 粘贴过滤
	let handlePaste = (e) => {
		e.preventDefault();
		let pasteContent = '';
		if (e.clipboardData?.getData) {
			pasteContent = e.clipboardData.getData('text/plain');
		}
		const pureNumber = pasteContent.replace(/[^0-9]/g, '');
		
		// Vue 中处理光标位置（需获取 DOM 元素）
		const input = e.target;
		const startPos = input.selectionStart;
		const endPos = input.selectionEnd;
		form.account = 
			form.account.substring(0, startPos) + 
			pureNumber + 
			form.account.substring(endPos);
		input.selectionStart = input.selectionEnd = startPos + pureNumber.length;
	};
	
	const emit = defineEmits(['success','close']);
	let doLogin = ()=>{
		if(isReg.value){
			if(!agree.value){
				return proxy.$message.warning('请先同意协议');
			}
		}else{
			
		}
		
		formRef.value.validate((valid)=>{
			if (valid) {
				form.account = proxy.filterNonNumeric(form.account);//过滤非数字
				let _form = Object.assign({},form,{type:loginMode.value});
				_form.account = `${_form.p}_${_form.account}`;
				delete _form.p;
				userLogin(_form);
			}
		})
	}
	let userLogin = (data)=>{
		if(MFARef.value.visible){
			MFARef.value.confirmLoading = true;
		}
		// let url = loginMode.value == 0 ? "Member/SignIn_Do" : "Member/SignIn_Phone";
		let url = "UserLogin";
		loading.value = true;
		return proxy.request({
			url: url,
			method: "post",
			data,
		}).then(res=>{
			let data = res?.data||{};
			if (data.code == 200) {
				proxy.localStorage.setItem("token", data.data.accessToken);
				store.action.user.resetUserStore();
				data.data.mobile = data.data.mobile??'';
				store.action.user.updateUser(data.data);
				// proxy.localStorage.setItem('userInfo',JSON.stringify(data.data));
				console.log("登录成功",data.data);
				if(data.data.updatedNickname!==0){//设置过昵称才需要关闭弹窗
					!isReg.value&&emit('success',data.data);
				}
				// 重置表单
				Object.assign(form,{
					p:'86',
					account:'',
					password:'',
					mfaCode:'',
				});
				if(isReg.value&&proxy.$route.query.recommendCode){//上报注册
					proxy.userActivityEvent({
						code:0,
						paramId:proxy.$route.query.recommendCode,
					});
				}
				MFARef.value.close();
			}else if(data.code == 10086){
				console.log('需要开启MFA',data),
				// 需要开启MFA
				MFARef.value.show();
			}else{
				// MFARef.value.clear();
				form.mfaCode = '';
			}
			return res;
		}).catch(err=>{
			console.log(err);
		}).finally(()=>{
			if(MFARef.value.visible){
				MFARef.value.confirmLoading = false;
			}
			loading.value = false;
		})
	}
	
	// 去注册
	let doreg = (_regStep)=>{
		formRef.value.validate((valid)=>{
			if (valid) {
				if(!agree.value){
					return proxy.$message.warning('请先同意协议');
				}
				if(regStep.value==1 && _regStep==2){
					validPhoneCode();
				}
				if(_regStep == 3){
					if(/\s+/.test(userInfoOpt.editModel.nickName)){
						return proxy.$message.warning('昵称不能设置空内容哦');
					}
					userRegister();
				}
			}
		})
	}
	// 校验手机验证码
	let validPhoneCode = ()=>{
		loading.value = true;
		form.account = proxy.filterNonNumeric(form.account);//过滤非数字
		let _form = Object.assign({},form,{codeType:loginMode.value});
		console.log('注册前的字段',_form);
		_form.phoneno = `${_form.p}_${_form.account}`;
		_form.verCode = _form.password;
		_form.password = _form.password1;
		delete _form.p;
		return proxy.request({
			url:'validPhoneCode',
			data:_form,
			method:'post',
		}).then(({data})=>{
			if(data.code == 200){
				form.password1 = '';
				form.password2 = '';
				form.verCode = '';
				proxy.clearObject(rules);
				Object.assign(rules,_rules[2]);
				console.log('校验规则：',rules,_rules[2]);
				regStep.value = 2;
			}
		}).catch(err=>{
			console.log(err);
		}).finally(()=>{
			loading.value = false;
		})
	}
	let userRegister = ()=>{
		let url = "UserRegister";
		loading.value = true;
		form.account = proxy.filterNonNumeric(form.account);//过滤非数字
		let _form = Object.assign({},form,{type:loginMode.value});
		console.log('注册前的字段',_form);
		_form.phoneno = `${_form.p}_${_form.account}`;
		_form.verCode = _form.password;
		_form.password = _form.password1;
		delete _form.p;
		delete _form.password1;
		delete _form.password2;
		delete _form.account;
		if(proxy.$route.query.recommendCode){
			Object.assign(_form,{recommendCode:proxy.$route.query.recommendCode});
		}
		return proxy.request({
			url: url,
			method: "post",
			data:_form,
		}).then(async({data})=>{
			if (data?.code == 200) {
				// proxy.$message({
				// 	type: "success",
				// 	// duration: 1000,
				// 	message: "注册成功!",
				// });
				// loginModeChange(2);//密码登录
				// isReg.value = false;
				// regStep.value = 1;
				// allowReg.value = false;
				// title.value = '登录';
				// obtainVerificationCode.value = '获取验证码';
				if(isReg.value&&proxy.$route.query.recommendCode){//上报注册
					proxy.userActivityEvent({
						code:0,
						paramId:proxy.$route.query.recommendCode,
					});
				}
				// 注册成功后自动登录
				await proxy.awaitTime(300);
				recursiveLogin(_form);
			}
		}).catch(err=>{
			console.log(err);
		}).finally(()=>{
			loading.value = false;
		})
	}
	let doUpdatedNickname = async (newestUserInfo)=>{
		title.value = '设置昵称';
		regStep.value = 4;
		userInfoOpt.editModel.avatar = newestUserInfo.photo || "";
		return;
	}
	let recursiveLogin = async(_form)=>{
		try{
			let res = await userLogin({
				account:_form.phoneno,
				password:_form.password,
				type: 2,
			});
			if(res?.data?.code == 200){
				title.value = '设置昵称';
				regStep.value = 4;
			}else{
				proxy.$confirm('自动登录失败，是否重试？','提示',{
					confirmButtonClass: 'confirmButtonClass'
				}).then(()=>{
					recursiveLogin(_form);
				}).catch(()=>{//回到账号登录界面
					loginModeChange(2);//密码登录
					isReg.value = false;
					regStep.value = 1;
					allowReg.value = false;
					title.value = '登录';
					obtainVerificationCode.value = '获取验证码';
				})
			}
		}catch(err){
			console.log('登录失败',err);
		}
	}
	let isReg = ref(false),
		regStep = ref(1),
		allowReg = ref(false),
		cachePassword = {password1:null,password2:null},
		agree = ref(false),
		old_loginMode = 2;
	onMounted(()=>{
		// isReg.value = true;
		// regStep.value = 4;
	})
	let reg = ()=>{
		isReg.value = !isReg.value;
		if(isReg.value){
			old_loginMode = loginMode.value;
		}
		loginModeChange(isReg.value?1:old_loginMode);
		/* if(isReg.value){//测试代码
			regStep.value = 2;
			form.password1 = '';
			form.password2 = '';
			proxy.clearObject(rules);
			Object.assign(rules,_rules[2]);
			console.log('校验规则：',rules);
		} */
		title.value = isReg.value?'注册':'登录';
		obtainVerificationCode.value = '获取验证码';
	}
	// 随机密码
	let randomPassword = ref('');
	let randomPasswordFn = ()=>{
		randomPassword.value = proxy.newGuid().replace(/-/g,'').split('').slice(0,15).join('');
		if(form.password1!==''){
			cachePassword.password1 = form.password1;
		}
		if(form.password2!==''){
			cachePassword.password2 = form.password2;
		}
		form.password1 = randomPassword.value;
		form.password2 = randomPassword.value;
		showPassword1.value = true;
		proxy._copyText(randomPassword.value).then(()=>{
			proxy.$message.success('随机密码已复制');
		})
	}
	let showPassword1Ref = ref();
	let clickPassword = ()=>{
		if(randomPassword.value){
			// document.querySelector()
			// console.log(showPassword1Ref.value);
			showPassword1Ref.value.blur();
			proxy.$messageBox.alert('随机密码太复杂？','提示',{
				showCancelButton:true,
				cancelButtonText:'否',
				confirmButtonText:'是',
				confirmButtonClass:'confirmButtonClass-primary',
			}).then(()=>{
				if(cachePassword){
					form.password1 = cachePassword.password1;
					form.password2 = cachePassword.password2;
					cachePassword = {password1:null,password2:null};
					showPassword1.value = false;
				}
				randomPassword.value = '';
			})
		}
	}
	let disabledGetCode = false,
		getCodeloading = ref(false);
	let getCode = ()=>{
		if(disabledGetCode)return;
		if(form.account===''){
			return proxy.$message.error('请先输入手机号');
		}
		form.account = proxy.filterNonNumeric(form.account);
		// else if(form.account.length<11){
		// 	return proxy.$message.error('请输入完整的手机号');
		// }
		disabledGetCode = true;
		getCodeloading.value = true;
		proxy.request({
			url:'SendVerifyCode',
			method:'post',
			data:{
				phoneno:`${form.p}_${form.account}`, 
				codeType:isReg.value?1:2,//2026年1月15日17:56:44
				// codeType:2,//登录注册都发同一个（2025年8月20日11:11:31）
			}
		}).then(({data})=>{
			if(data.code==200){
				proxy.$message.success('验证码发送成功!');
				setGetCodeInterval().finally(()=>{
					disabledGetCode = false;
				});
			}else{
				disabledGetCode = false;
			}
		}).catch(err=>{
			console.log(err);
			disabledGetCode = false;
		}).finally(()=>{
			getCodeloading.value = false;
		})
	}
	let getCodeInterval = null;
	let setGetCodeInterval = ()=>{
		return new Promise((reolve,reject)=>{
			let time = 60;
			clearInterval(getCodeInterval);
			getCodeInterval = setInterval(()=>{
				obtainVerificationCode.value = `${--time}秒后重试`;
				if(time<=0){
					clearInterval(getCodeInterval);
					getCodeInterval = null;
					obtainVerificationCode.value = `重新获取验证码`;
					reolve();
				}
			},1000);
		})
	}
	let setPasswordForm = reactive({
			
		}),
		setPasswordRules = {
			
		},
		setPassword = ref(false);
	
	let setPasswordFn = (v)=>{
		setPassword.value = v;
	}
	let forgotPasswordFn = ()=>{
		// console.log('忘记密码',store.state.user);
		proxy.$router.push('/changePassword');
		close();
	}
	let close = ()=>{
		cacheAccount.value = '';
		if(loginMode.value != 3){
			proxy.clearObject(form);
			_form[loginMode.value].p = '86';
			Object.assign(form,_form[loginMode.value]);
		}else{
			// 重置二维码
			clearInterval(qrcodeOpt.countdownInterval);
			clearInterval(qrcodeOpt.qrLoginStatusInterval);
			Object.assign(qrcodeOpt,{
				loading:false,
				text:'',
				eventID:'',
				countdownInterval:null,
				expireTime:0,
				status:0,
			});
			loginMode.value = 1;
		}
		if(props.mode==1){
			emit('close');
		}else{
			proxy.$router.back();
		}
	}
	let toAgreement = ()=>{
		// 新窗口打开协议
		proxy.openAppRoute(proxy.$router, '/other/user-related/userAgreement');
	}
	let MFARef = ref();
	let MFASuccess = (e)=>{
		console.log("MFA",e);
		Object.assign(form,{mfaCode:e});
		console.log('MFA-form:',form);
		doLogin();//执行登录
	}
	
	let avatarError = (e)=>{
		e.target.src = defaultAvatar;
	}
	const vAutofocus = {
		mounted:(el,vbond,vnode)=>{
			vbond.instance.$nextTick(async()=>{
				await proxy.awaitTime(300);
				el.querySelector('input').focus();
			})
		}
	}

	let userInfoOpt = reactive({
		loading:false,
		uploading:false,
		editModel:{
			nickName:'',
			avatar:''
		},
		complete:async()=>{
			try{
				// 如果用户不修改，直接点完成
				// let pass = true;
				// if(userInfoOpt.editModel.nickName == userInfoOpt.editModel._nickName){
				// 	await proxy.$confirm('改一个酷酷的名字让主播记住你！', '提示', {
				// 		confirmButtonText: '改一个',
				// 		cancelButtonText: '不改了',
				// 		type: 'info',
				// 		confirmButtonClass: 'confirmButtonClass-primary'
				// 	}).then(() => {
				// 		pass = false;
				// 	}).catch(()=>{
				// 		pass = true;
				// 	})
				// }
				// if(!pass)return;
				userInfoOpt.loading = true;
				let nickName = userInfoOpt.editModel.nickName;
				// if(nickName===''){//用户什么也不输入的时候
				// 	nickName = userInfoOpt.editModel._nickName;//使用回默认名字
				// }
				if(nickName.trim() === ""){
					return proxy.$message.error('请输入昵称');
				}
				let res = await userInfoUpdate({
					avatar:userInfoOpt.editModel.avatar,
					nickName,
				});//更新用户信息
				console.log('更新用户信息结果',res);
				if(res?.data.code == 200){
					userInfoOpt.editModel={
						nickName:'',
						avatar:''
					};
					close();
					loginModeChange(2);//密码登录
					isReg.value = false;
					regStep.value = 1;
					allowReg.value = false;
					title.value = '登录';
					obtainVerificationCode.value = '获取验证码';
				}
			}catch(err){
				console.log('complete',err);
			}finally{
				userInfoOpt.loading = false;
			}
		},
		beforePhotoUpload:(file)=>{
			const isJPGorPNG = file.type === 'image/jpeg' || file.type === 'image/png';
			const isLt2M = file.size / 1024 / 1024 < 2;
			
			if (!isJPGorPNG) {
				proxy.$message.error('请上传JPG或PNG格式的图片');
				return false;
			}
			if (!isLt2M) {
				proxy.$message.error('图片大小不能超过2MB');
				return false;
			}
			return true;
		},
		handleUpload:(options)=>{
			var currentFile = options.file;
			userInfoOpt.uploading = true;
			console.log('文件',currentFile);
			let params = {
				extName:'.' + currentFile.type.split('/')[1],
				onProgress:(e)=>{
					console.log('onProgress',e);
				},
			}
			proxy.uploadFile(params,currentFile).then((url)=>{
				console.log('uploadFile',url);
				options.onSuccess({
					url,
					file: currentFile
				});
			}).catch(err=>{
				options.onError(err);
			}).finally(()=>{
				userInfoOpt.uploading = false;
			})
		},
		handleProgress:(event, file, fileList)=>{
			
		},
		handlePhotoUploadSuccess:(response)=>{
			if(!response?.url) return;
			console.log("handlePhotoUploadSuccess", response);
			proxy.$message.success('文件上传成功');
			userInfoOpt.editModel.avatar = response.url;
			// userInfoUpdate({avatar:response.url});//更新用户头像
			avatarUploadRef.value.clearFiles();//清空已上传的文件
		},
		handleUploadError:(err)=>{
			proxy.$message.error('上传失败，请检查网络连接'+err);
		},
	})
	let avatarUploadRef = ref();
	watch(()=>userInfo.value.photo,(photo)=>{
		userInfoOpt.editModel.avatar = photo;
	});
	watch(()=>userInfo.value.nickName,(nickName)=>{
		// userInfoOpt.editModel.nickName = nickName;
		userInfoOpt.editModel._nickName = nickName;
	});
	watch(()=>userInfo.value.id,(id,oldId)=>{
		// 用户反馈大量弹出，本不应该弹的也弹。先收敛弹出时机
		// if(id && !oldId){//id从无到有，说明是登录
		// 	if(userInfo.value.updatedNickname === 0){//没有设置过昵称需要强制去设置
		// 		doUpdatedNickname();
		// 	}
		// }
	});

	let userInfoUpdate = async(editPart)=>{
		try{
			var res = await proxy.request({
				url: "UserInfoUpdate",
				data: editPart,
				method: "POST"
			});
			if(res.status != 200) throw "保存失败，收到了意外的回复！";
			if(res.data.code != 200) throw "保存失败，" + res.data.msg;
			proxy.userActivityEvent({
				code:23,//完善个人信息
			});
			let _userinfo = {};
			Object.assign(_userinfo,editPart);
			if(editPart.avatar){
				Object.assign(_userinfo,{
					photo: editPart.avatar,
				})
			}
			Object.keys(editPart).forEach(k=>{
				if(k == 'gender'){
					Object.assign(_userinfo,{sex:editPart[k]==0?3:editPart[k]});
				}
			})
			store.action.user.updateUser(Object.assign({},userInfo.value,_userinfo));//更新用户信息
			return res;
		}catch(err){
			console.log('userInfoUpdate-err:',err);
		}
	}

	defineExpose({
		regStep,
		doUpdatedNickname,
	})
	
</script>

<style lang="scss" scoped>
    .loginBox {
        width: 588px;
        height: 512px;
        background: rgba(255,255,255,1);

        .top {
            width: 588px;
            height: 62px;
            background: var(--qx2-primary-linearGradient-color);
            position: relative;
            display: flex;
            align-items: center;

            .parallelogram {
                background: rgba(255,255,255,1);
                width: 178px;
                height: 63px;
                clip-path: polygon(25% 0%, 100% 0%, 75% 100%, 0% 100%);
                position: absolute;
                top: 0;
                left: 7px;
                z-index: 0;
            }

            .left {
                margin-left: 7px;
                position: relative;
                z-index: 1;
                display: flex;
                align-items: center;

                .logo {
					width: 178px;
                    img {
                        width: auto;
                        height: 30px;
                        margin-right: 2px;
                        // margin-left: 15px;
                    }

                    .text {
                        font-family: BigruixianBlackGBV;
                        font-weight: 400;
                        font-size: 20px;
                        color: #000000;
                    }
                }

                .title {
                    font-size: 16px;
                    color: #FFFFFF;
                    font-weight: bold;
                }
            }

            .close {
                width: 26px;
                height: 26px;
                position: absolute;
                top: 50%;
                right: 24px;
                transform: translateY(-50%);
                cursor: pointer;

                &:before, &:after {
                    content: '';
                    width: 30px;
                    height: 3px;
                    border-radius: 2px;
                    background: #fff;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }

                &:before {
                    transform: translate(-50%,-50%) rotate(45deg);
                }

                &:after {
                    transform: translate(-50%,-50%) rotate(-45deg);
                }
            }
        }

        .main {
            width: 369px;
            margin: 0 auto;

            .switchLogoMode {
                position: relative;
                width: 368px;
                height: 52px;
                margin: 30px auto 0;
                display: flex;
				gap: 10px;
                align-items: center;
                font-size: 16px;
                color: #8F8F8F;

                .item {
                    width: 33%;
                    height: 21px;
                    cursor: pointer;
                    transition: all 0.3s;

                    &.active {
                        font-family: PingFang-SC-Bold;
                        // font-weight: bold;
                        font-size: 16px;
                        color: #000000;
                    }
                }

                .line {
                    width: 368px;
                    height: 2px;
                    background: #C8E5C8;
                    position: absolute;
                    left: 0;
                    bottom: 0;

                    .act {
                        position: absolute;
                        left: 0%;
                        width: 33%;
                        height: 100%;
                        background: var(--qx2-primary-linearGradient-color);
                        transition: all 0.3s;

						&.toCenter{
                            left: 33%;
						}
						&.toRight {
                            left: 66%;
                        }
                    }
                }
            }

            .formBox {
                .el-form {
					margin-top: 52px;
                    width: 100%;

                    .el-form-item {
                        :deep(.el-form-item__content) {
                            flex-wrap: nowrap;

                            .el-input-group__append {
                                border: unset;
                                box-shadow: unset;
                            }
                        }

                        .showPassword {
                            cursor: pointer;

                            img {
                                width: 21px;
                                height: 14px;
                            }
                        }
						.password1{
							width:100%;
							position:relative;
							.iconDice{
								position:absolute;
								top:50%;
								left:100%;
								transform: translate(7px,-50%);
								width:18px;
								height:18px;
								cursor:pointer;
							}
						}
						
                    }
                }

                .obtainVerificationCode {
                    width: 126px;
                    height: 44px;
                    background: #F0F0F0;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #999999;
                    margin-left: 9px;
                    cursor: pointer;
                    border: unset;
                }

                .el-select {
                    margin-right: 9px;

                    :deep(.el-select__wrapper) {
                        background-color: #F2F7FA;
                        border: unset;
                        box-shadow: unset;
                        height: 44px;
                    }
                }

                .el-input {
                    :deep(.el-input__wrapper) {
                        background-color: #F2F7FA;
                        border: unset;
                        box-shadow: unset;
                        height: 44px;
                    }
                }
				.el-row{
					width:100%;
				}
				.avatar-wrapper {
					position: relative;
					width: 100px;
					height: 100px;
					border-radius: 50%;
					margin-bottom: 10px;
					:deep(.el-upload){
						width: 100%;
						height: 100%;
					}
					.avatarBox{
						width: 100%;
						height: 100%;
						position:relative;
						.iconBox{
							width: 30px;
							height: 30px;
							position: absolute;
							bottom: 0;
							right:0;
							transform: translate(-50%,0);
							border-radius:50%;
							background:#fff;
							.el-icon{
								color:var(--qx2-primary-color);
							}
						}
						.avatar {
							width: 100%;
							height: 100%;
							object-fit: cover;
							border-radius: 50%;
							overflow: hidden;
							box-shadow: 0 0 6px #eee;
						}
					}
				}
				.nickName{
					width: 369px;
					background: rgba(242,247,250,1);
					border-radius: 4px;
					:deep(.el-input__inner){
						text-align:center;
					}
				}
				.scanToLogin{
					margin-top:42px;
					.qrcodeBox{
						width: 218px;
						height: 218px;
						// background: rgba(255,255,255,1);
						box-shadow: 0px 0px 6px rgba(0,45,0,0.16);
						border-radius: 14px;
						margin-bottom: 22px;
						position: relative;
						.status{
							position: absolute;
							top:0;
							left:0;
							right:0;
							bottom:0;
							z-index:9;
							cursor: pointer;
							background: rgba(0,0,0,0.65);
							color:#fff;
						}
					}
					.tips{
						.text{
							font-family: MicrosoftYaHei;
							font-weight: 400;
							font-size: 14px;
							color: #000000;
							&.appText{
								color:var(--qx2-primary-color);
							}
						}
						.iconRefresh{
							width: 20px;
							cursor: pointer;
							margin-left: 5px;
						}
					}
				}
            }

            .other {
                width: 100%;
                display: flex;
                justify-content: flex-end;

                .forgotPassword {
                    transform: translateY(-50%);
                }
            }

            .btnBox {
                display: flex;
                flex-direction: column;

                .item {
                    width: 369px;
                    height: 50px;
                    margin-bottom: 26px;
                    border-radius: 4px;
                    margin-left: unset;

                    &.login {
                        background: var(--qx2-primary-linearGradient-color);
                        font-family: PingFang-SC-Bold;
                        // font-weight: bold;
                        font-size: 18px;
                        color: #FFFFFF;

                        &.grey {
                            background: #dcdcdc;
                        }
                    }

                    &.reg {
                        background: #fff;
                        font-family: PingFang-SC-Bold;
                        // font-weight: bold;
                        font-size: 18px;
                        color: var(--qx2-primary-color);
                        border: 2px solid var(--qx2-primary-color);
                    }
                }
            }
        }
    }
	:deep(.customLabel){
		width: 315px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-family: MicrosoftYaHei;
		font-size: 14px;
		border-bottom: 1px solid #E8E8E8;
		.label{
			color: #060606;
			.flag{
				width:20px;
				height:20px;
				margin-right:3px;
				img{
					width:100%;
					height:100%;
					object-fit: scale-down;
					vertical-align: top;
				}
			}
		}
		.tel{
			color: #6D7278;
		}
	}
	.loginBox.compact {
		width: 280px !important;
		height: auto;
		min-height: 0;
		.top{
			width: 100%;
			height: 52px;
			.parallelogram{ display: none; }
			.left{
				margin-left: 0px !important;
				.logo{
					width: auto;
					img{ height: 24px; }
					.text{ display: none; }
				}
				.title{
					font-size: 14px;
					margin-left: 8px;
				}
			}
			.close{ right: 12px; }
		}
		.main{
			width: calc(100% - 20px);
			padding-bottom: 10px;
			.switchLogoMode{
				width: 100%;
				.line{ width: 100%; }
			}
			.formBox{
				margin-top: 16px;
				.el-form .el-form-item {
					.mobileAreaCode{
						width: 84px !important;
					}
					:deep(.el-form-item__content){
						gap: 6px;
					}
					:deep(.el-input){
						width: auto !important;
						flex: 1 1 auto;
						min-width: 0;
					}
				}
				.obtainVerificationCode{
					width: 92px;
					height: 40px;
					font-size: 12px;
					margin-left: 0;
					padding: 0 6px;
				}
				.el-select :deep(.el-select__wrapper),
				.el-input :deep(.el-input__wrapper){
					height: 40px;
				}
			}
			.btnBox .item{
				width: 100%;
				height: 44px;
				margin-bottom: 14px;
				font-size: 16px;
			}
		}
	}
</style>